export default function () {
  return {
    token: null, // JWT
    user: null,
    client: null
  }
}
